<template>
    <ui-modal title="Update status" :close="close">
        <ui-form-section class="mt-6">
            <ui-select-searchable
                label="Status"
                placeholder="Select a status..."
                v-model="form.status"
                :error="form.errors.get('status_id')"
                :options="statuses"
                option-label="name"
            >
                <template #option="{ name, description }">
                    <p v-text="name"></p>
                    <p v-text="description" class="text-sm opacity-60 italic -mt-0.5 mb-0.5"></p>
                </template>
            </ui-select-searchable>
        </ui-form-section>
        <template #footer-primary>
            <ui-button-new primary class="w-full" :loading="form.busy" @click="form.submit()">Save</ui-button-new>
        </template>
    </ui-modal>
</template>

<script>
import { Package } from '@models'

export default {
    props: {
        close: Function,
        packageItem: Object,
    },
    data () {
        return {
            statuses: [],
            form: new Form({ status: this.packageItem.status }, async (form) => {
                if (this.packageItem.status.id === form.status.id) return
                await this.packageItem.updateStatus(form.status.id)
                this.close()
            })
        }
    },
    async mounted () {
        this.statuses = await Package.getStatuses()
    },
}
</script>
